import { ReactNode, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';

type Props = {
  entity: string | string[];
  action: 'canRead' | 'canWrite' | 'canUpdate' | 'canDelete';
  children: ReactNode;
};

function CanAccess({ entity, action, children }: Props) {
  const roles = useSelector((state: RootState) => state.user.user.roles);

  const permissions = useMemo(() => {
    const applicationPermission: Record<string, Record<string, boolean>> = {};
    if (Array.isArray(roles)) {
      for (const role of roles) {
        const rolePermission = role.permissions;
        if (rolePermission && typeof rolePermission === 'object') {
          for (const key in rolePermission) {
            if (Object.prototype.hasOwnProperty.call(rolePermission, key)) {
              const value = rolePermission[key];
              if (key in applicationPermission) {
                const existingValue = applicationPermission[key];
                for (const valueKey in existingValue) {
                  if (
                    Object.prototype.hasOwnProperty.call(
                      existingValue,
                      valueKey
                    )
                  ) {
                    if (value[valueKey] === true) {
                      applicationPermission[key][valueKey] = true;
                    }
                  }
                }
              } else {
                applicationPermission[key] = value;
              }
            }
          }
        }
      }
    }
    return applicationPermission;
  }, [roles]);

  const isAccessible = Array.isArray(entity)
    ? entity.some(item => permissions[item]?.[action])
    : permissions[entity]?.[action];

  if (!roles || (roles && roles.length === 0) || isAccessible) return children;

  return null;
}

export default CanAccess;
